<template>
  <div>
    <Scroll
      :refresh_status.sync="refresh_status"
      :load_status.sync="load_status"
      :page.sync="page"
      :total_pages="total_pages"
      :list="list"
      @refresh="RefreshList"
      @loadmore="GetList">
      <div class="page-title">{{info.class_name}}饮水排行榜</div>
      <!-- tab -->
      <TabbarCartoon :list="tab_list" v-model="tab_index" />
      <!-- item列表 -->
      <div class="student-item" v-for="(item, index) in list" :key="index">
        <img :src="Images['IconDiyiming' + item.rank]" v-if="item.rank <= 3" class="diyiming-icon" />
        <div class="grade-number wechatNumber" v-else>{{item.rank}}</div>
        <img :src="item.student_gender * 1 === 2 ? Family6 : Family5" class="head-img" />
        <div class="name">{{item.student_name}}</div>
        <div class="number"><span class="wechatNumber">{{item.amount}}</span></div>
      </div>
    </Scroll>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  import { ListPage } from '@/utils/Mixin'
  export default {
    mixins: [ListPage],
    data () {
      return {
        tab_list: [
          { title: '日', code: 1 },
          { title: '周', code: 2 }
        ],
        tab_index: 0,
        info: {}
      }
    },
    methods: {
      GetList () {
        this.$Get('Common.WaterGetRankInfo', {
          cup_id: this.$route.query.id,
          tab: this.tab_list[this.tab_index]['code'],
          page: this.page,
          limit: 10
        }).then(({ data }) => {
          this.info = data
          this.HandleRes(data)
        })
      }
    },
    watch: {
      tab_index () {
        this.RefreshList()
      }
    },
    computed: {
      ...SetImage(['Family5', 'Family6']),
      ...SetImage(['IconDiyiming1', 'IconDiyiming2', 'IconDiyiming3'], { bundle: true })
    }
  }
</script>

<style lang="less" scoped>
  .page-title {
    .fz(.34rem);
    .c(#333);
    text-align: center;
    font-weight: bold;
    .mb(.73rem);
    .mt(.36rem);
  }
  .student-item {
    .h(1.62rem);
    border-bottom: 1px solid #e5e5e5;
    .m(0 .3rem);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .pl(1.03rem);
    .pr(.35rem);
    position: relative;
    .diyiming-icon {
      .w(.43rem);
      .h(.57rem);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: .29rem;
    }
    .grade-number {
      .w(.42rem);
      .h(.42rem);
      .br(.21rem);
      .bg(#ffc000);
      .lh(.42rem);
      box-sizing: border-box;
      text-align: center;
      .fz(.32rem);
      .c(#fff);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: .29rem;
    }
    .head-img {
      .w(1rem);
      .h(1rem);
      .mr(.14rem);
    }
    .name {
      .fz(.3rem);
      .c(#333);
      font-weight: bold;
      .mr(auto;)
    }
    .number {
      .c(#00b0f4);
      .fz(.28rem);
      .wechatNumber {
        .fz(.44rem);
        font-weight: bold;
      }
    }
  }
</style>
